<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="$modal.closeModal"
    >
      <header class="m-the-modal-header">
        <h5>ACCIÓN DESHABILITADA</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>Este punto de venta está relacionado con la venta de uno o más productos, para poder desactivarlo de manera global primero debes desactivar su relación de venta.</p>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingSalesDataModalActionDisabled',

  data () {
    return {
      buttonPrimary: {
        action: 'ENTENDIDO',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      }
    }
  }
}
</script>
